listCacheClear